import React, {useEffect, useState} from 'react';
import { Loader } from "semantic-ui-react";
import { size, map } from "lodash";
import { Level } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { LevelItem } from "../LevelItem/LevelItem";

const levelController = new Level();

export function ListLevel(props) {

  const { reload, onReload } = props;
  const [levels, setLevels] = useState(null);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        setLevels(null);
        const response = await levelController.getLevels(accessToken);
        setLevels(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [reload, accessToken]);

  if (!levels) return <Loader active inline="centered" />;
  if (size(levels) === 0) return "No existen niveles registradas";

  return map(levels, (level) => (
    <LevelItem key={level.id} level={level} onReload={onReload} />
  ));
}
